export default function ({app, redirect, store}) {
    let route = app.$redirectPathDefault();
    if(route.path != '/dashboard') {
        return redirect(302, route)
    }
}